import { render, staticRenderFns } from "./SemesterCardGroup.vue?vue&type=template&id=b79c0078&"
import script from "./SemesterCardGroup.vue?vue&type=script&lang=js&"
export * from "./SemesterCardGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports